import { Module } from "wrapper6";

var $ = jQuery;

export default class ShippingSelect extends Module {

    ready(app) {
        $(document).on('click', '.product_shipping_class:not(.active)', function () {
            $('.mtt-shipping').addClass('loading');

            var option = $(this);

            var data = {
                action: 'select_shipping_method',
                shipping_method: option.data('shipping_method'),
                package_key: option.parent('.mtt-shipping').data('package_key'),
            };

            $.post(main_theme_objects.ajax_url, data, function(response) {
                if(response.hasOwnProperty('success') && response.success) {
                    $('.product_shipping_class.active').removeClass('active');
                    option.addClass('active');
                    $('.mtt-shipping').removeClass('loading');

                    $(document.body).trigger("updated_shipping_method");
                    $(document.body).trigger('update_checkout');
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_shipping-select.js